import React, { useCallback, useEffect, useState } from "react";
import { api, asAbsolute } from "@/lib/api";
import { toast } from "sonner";
import { Pencil, Trash2, Plus, X, Save } from "lucide-react";
import FileUploader from "./FileUploader";

const empty = { name: "", role: "", bio: "", image: "", order: 100 };

export default function AdminTeam() {
    const [items, setItems] = useState([]);
    const [form, setForm] = useState(null);
    const load = useCallback(() => api.get("/team").then((r) => setItems(r.data || [])), []);
    useEffect(() => { load(); }, [load]);

    const save = async () => {
        try {
            const payload = { ...form, order: Number(form.order) || 100 };
            if (form.id) await api.put(`/team/${form.id}`, payload);
            else await api.post("/team", payload);
            toast.success("Saved");
            setForm(null);
            load();
        } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    };
    const remove = async (id) => {
        if (!window.confirm("Delete member?")) return;
        await api.delete(`/team/${id}`);
        load();
    };

    return (
        <div data-testid="admin-team">
            <div className="flex items-end justify-between mb-6">
                <div>
                    <h1 className="text-2xl font-semibold">Team</h1>
                    <p className="text-sm text-slate-500 mt-1">Leadership & team on the About page.</p>
                </div>
                <button onClick={() => setForm({ ...empty })} data-testid="team-add-btn" className="px-4 py-2 rounded-md bg-brand-forest text-white text-sm font-semibold inline-flex items-center gap-2"><Plus size={14} /> Add member</button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {items.map((m) => (
                    <div key={m.id} className="bg-white border border-slate-200 rounded-lg overflow-hidden">
                        {m.image && <div className="aspect-square overflow-hidden"><img src={asAbsolute(m.image)} alt={m.name} className="w-full h-full object-cover" /></div>}
                        <div className="p-4">
                            <div className="font-semibold">{m.name}</div>
                            <div className="text-xs text-brand-forest font-semibold uppercase tracking-wide">{m.role}</div>
                            <p className="text-sm text-slate-600 mt-2 line-clamp-3">{m.bio}</p>
                            <div className="flex justify-end gap-1 mt-3">
                                <button onClick={() => setForm({ ...m })} className="p-1.5 hover:bg-slate-100 rounded"><Pencil size={13} /></button>
                                <button onClick={() => remove(m.id)} className="p-1.5 hover:bg-red-50 text-red-600 rounded"><Trash2 size={13} /></button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {form && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-6" onClick={() => setForm(null)}>
                    <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg max-w-lg w-full">
                        <div className="flex items-center justify-between p-5 border-b border-slate-200"><h2 className="font-semibold">{form.id ? "Edit member" : "Add member"}</h2><button onClick={() => setForm(null)}><X size={18} /></button></div>
                        <div className="p-5 space-y-3">
                            <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-3 py-2 rounded border border-slate-200 text-sm" />
                            <input placeholder="Role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full px-3 py-2 rounded border border-slate-200 text-sm" />
                            <textarea rows="4" placeholder="Bio" value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} className="w-full px-3 py-2 rounded border border-slate-200 text-sm resize-none" />
                            <FileUploader kind="image" current={form.image} label="Profile photo" onUploaded={(r) => setForm({ ...form, image: r.url })} />
                            <input placeholder="Or image URL" value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} className="w-full px-3 py-2 rounded border border-slate-200 text-sm" />
                            <input type="number" placeholder="Order" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} className="w-full px-3 py-2 rounded border border-slate-200 text-sm" />
                        </div>
                        <div className="p-5 border-t border-slate-200 flex justify-end gap-2">
                            <button onClick={() => setForm(null)} className="px-4 py-2 rounded text-sm">Cancel</button>
                            <button onClick={save} className="px-4 py-2 rounded bg-brand-forest text-white text-sm font-semibold inline-flex items-center gap-2"><Save size={14} /> Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
